(() => {
  const key = 'tn-favorites-v1';
  const panel = document.querySelector('#tn-favorites');
  if (!panel) return;
  const root = window.TN?.root || '/';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let saved = [], revision = 0;
  try { const parsed = JSON.parse(localStorage.getItem(key) || '[]'); saved = Array.isArray(parsed) ? parsed.filter(p => typeof p.handle === 'string' && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title === 'string').slice(0,100) : []; } catch {}
  function sync() {
    document.querySelectorAll('[data-favorite]').forEach(button => {
      const active = saved.some(p => p.handle === button.dataset.favorite);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${button.dataset.favoriteTitle} ${active ? 'favorilerden çıkar' : 'favorilere ekle'}`);
    });
    document.querySelectorAll('[data-favorites-count]').forEach(el => el.textContent = saved.length);
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch {
      const toast = document.querySelector('.tn-toast');
      if (toast) { toast.textContent = 'Tarayıcı depolaması kapalı; favorileriniz yalnızca bu sayfada korunabilir.'; toast.classList.add('is-visible'); setTimeout(() => toast.classList.remove('is-visible'),5000); }
    }
    sync();
  }
  async function render() {
    const current = ++revision;
    const list = panel.querySelector('[data-favorites-list]');
    if (!saved.length) { list.innerHTML = `<div class="tn-favorites-empty">Henüz favoriniz yok. Ürünlerdeki kalbe dokunarak kendi lezzet listenizi oluşturun.<a class="tn-button" href="${root}collections/all">Lezzetleri keşfet →</a></div>`; return; }
    list.innerHTML = saved.map(p => `<article class="tn-favorite-row" data-saved-handle="${escape(p.handle)}"><div><a href="${root}products/${encodeURIComponent(p.handle)}">${escape(p.title)}</a><div data-favorite-offer><a href="${root}products/${encodeURIComponent(p.handle)}">Ürünü incele →</a></div></div><button type="button" data-favorite-remove="${escape(p.handle)}" aria-label="${escape(p.title)} favorilerden çıkar">×</button></article>`).join('');
    // Refresh prices and availability on every opening. Failure leaves a useful product link.
    const queue = [...saved];
    async function worker() {
      while (queue.length && current === revision) {
        const item = queue.shift();
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}.js`);
          if (!response.ok) continue;
          const product = await response.json();
          if (current !== revision) return;
          const row = [...list.querySelectorAll('[data-saved-handle]')].find(el => el.dataset.savedHandle === item.handle);
          const variant = product.variants?.find(v => v.available);
          if (!row || !variant || product.variants.length !== 1) continue;
          const currency = window.Shopify?.currency?.active || 'TRY';
          const price = new Intl.NumberFormat('tr-TR',{style:'currency',currency}).format(variant.price/100);
          row.querySelector('[data-favorite-offer]').innerHTML = `<strong>${escape(price)}</strong><form action="${root}cart/add" method="post" data-add-form><input type="hidden" name="id" value="${escape(variant.id)}"><button type="submit" class="tn-button">Sepete ekle →</button></form>`;
        } catch {}
      }
    }
    await Promise.all([worker(),worker(),worker()]);
  }
  document.addEventListener('click', e => {
    const favorite = e.target.closest('[data-favorite]');
    if (favorite) {
      const handle = favorite.dataset.favorite;
      const exists = saved.some(p => p.handle === handle);
      saved = exists ? saved.filter(p => p.handle !== handle) : [...saved,{handle,title:favorite.dataset.favoriteTitle}].slice(-100);
      persist();
    }
    if (e.target.closest('[data-favorites-open]')) { panel.showModal(); document.documentElement.classList.add('tn-modal-open'); render(); }
    if (e.target.closest('[data-favorites-close]')) panel.close();
    const remove = e.target.closest('[data-favorite-remove]');
    if (remove) { saved = saved.filter(p => p.handle !== remove.dataset.favoriteRemove); persist(); render(); }
  });
  panel.addEventListener('close', () => { revision++; document.documentElement.classList.toggle('tn-modal-open',!!document.querySelector('dialog[open]')); });
  document.addEventListener('tn:cart-added', () => { if(panel.open) panel.close(); });
  window.addEventListener('storage', e => { if(e.key === key) { try { const next=JSON.parse(e.newValue || '[]'); if(Array.isArray(next)) saved=next.filter(p=>typeof p.handle==='string' && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title==='string').slice(0,100); } catch {} sync(); if(panel.open) render(); } });
  sync();
})();
